module.exports = __webpack_public_path__ + "static/media/mail.b56cd23e.svg";